import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from './images/logo.png';
import UserMenuItem from './components/UserMenuItem/';
import PeopleSearcher from './components/PeopleSearcher/';
import OnboardingProcess from './components/OnboardingProcess/';
import listensToClickOutside from 'react-onclickoutside';
import './style.css';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      collapseIn: false,
    };
    this.handleToggleCollapse = this.handleToggleCollapse.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleToggleCollapse() {
    this.setState({
      collapseIn: !this.state.collapseIn,
    });
  }

  handleClickOutside() {
    this.setState({
      collapseIn: false,
    });
  }

  render() {
    const {
      isLoggedIn,
      userName,
      onLogout,
      companyLogo,
      isShowPeopleSearch,
      displayCommonProcessesGuideSwitch,
      // foundation 1.7 9.5 待需求再開時加回
      // onCompanySelect,
    } = this.props;

    return (
      <div id="navbar"
        className="header"
        role="navigation"
      >
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle"
              onClick={this.handleToggleCollapse}
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a
              className="navbar-brand header-logo ta__confirmation"
              href="/tube"
              onClick={this.props.onLinkClick}
            >
              <img src={ companyLogo || logo } />
            </a>
          </div>
          {
            isLoggedIn
            && (
              <div>
                <ul className="nav navbar-nav navbar-right">
                  <UserMenuItem
                    userName={userName}
                    onLogout={onLogout}
                    // onCompanySelect={onCompanySelect}
                    onLinkClick={this.props.onLinkClick}
                  />
                </ul>
                {
                  displayCommonProcessesGuideSwitch &&
                  <div className="navbar-right">
                    <OnboardingProcess />
                  </div>
                }
                {
                  isShowPeopleSearch &&
                  <div className="navbar-right peopleSearch">
                    <PeopleSearcher
                      history={this.props.history}
                    />
                  </div>
                }
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  history: PropTypes.object,
  userName: PropTypes.string,
  companyLogo: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  // onCompanySelect: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isShowPeopleSearch: PropTypes.bool.isRequired,
  displayCommonProcessesGuideSwitch: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func,
};
Header.defaultProps = {
  userName: '',
  isShowPeopleSearch: true,
  // 管理者權限
  displayCommonProcessesGuideSwitch: false,
};

export default listensToClickOutside(Header);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/components/Header/index.js
 **/